/* eslint-disable import/prefer-default-export */
export function elementContains(ref, target) {
    return ref && (ref === target || ref.contains(target));
}
